import { Box, Button, Grid, Typography } from '@mui/material';
import React, { useState } from 'react';
import genaiImg1 from "../../assets/images/genaiImg1.svg"
import genaiImg2 from "../../assets/images/genaiImg2.svg"
import genaiImg3 from "../../assets/images/genaiImg3.svg"
import genaiImg4 from "../../assets/images/genaiImg4.svg"

function GenratedImageComponent(props) {
    const [selectedImage, setSelectedImage] = useState()
    const generateImage = [{ id: 1, img: genaiImg1 }, { id: 2, img: genaiImg2 }, { id: 3, img: genaiImg3 }, { id: 4, img: genaiImg4 }];

  function onSelectImage(id) {
    setSelectedImage(id)
    // setGeneratePromptContentLoading(false)
  }
  
    return (
            <Box mt='1rem'>
                <Typography variant="subtitle2">Select Generated image</Typography>
                <Box sx={{ border: "1px solid #C5C5C5", borderRadius: 1 }}>
                    <Grid container spacing={1}>
                        {generateImage.map((data, index) => ( // Added parentheses and 'index' argument
                            <Grid item key={index} spacing={4}>
                                <Button variant={selectedImage === data.id && 'contained'} sx={{ p: 0.5 }} onClick={() => onSelectImage(data.id)} >
                                    <img src={data.img} alt="generateImage" width={72} height={73} />
                                </Button> {/* Access 'img' property */}
                            </Grid>
                        ))}
                    </Grid>
                </Box>
            </Box>
    );
}

export default GenratedImageComponent;